/*
 * <license header>
 */

import React from "react";
import ErrorBoundary from "react-error-boundary";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import CFEditorExtensionRegistration from "./CFEditorExtensionRegistration";
import LiveSiteInputModal from './LiveSiteInputModal';


function App() {
  return (
    <Router>
      <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
        <Routes>
          <Route index element={<CFEditorExtensionRegistration />} />
          <Route
            exact path="index.html"
            element={<CFEditorExtensionRegistration />}
          />
          <Route exact path="cf-editor" element={<CFEditorExtensionRegistration />} />
          <Route exact path="cf/:cfPath/aigeneration" element={<LiveSiteInputModal />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  )

  // Methods

  // error handler on UI rendering failure
  function onError(e, componentStack) {}

  // component to show if UI fails rendering
  function fallbackComponent({ componentStack, error }) {
    return (
      <React.Fragment>
        <h1 style={{ textAlign: "center", marginTop: "20px" }}>
          Phly, phly... Something went wrong :(
        </h1>
        <pre>{componentStack + "\n" + error.message}</pre>
      </React.Fragment>
    );
  }
}

export default App;
